/*
 *
 *  remotes
 *
 */

import api from "../../helpers/Api"
//import constantName from './key'

/**
 *
 * @param {string} metaData
 * @returns
 */

export function loadRecordsMetaData(metaData, method) {
  if (method === "post") {
    return api
      .post(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return api
      .get(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

// permission details
export async function loadFreelancerReportDetails(searchvalue) {
  // let unassigned

  if (searchvalue) {
    return await api

      .post(`/get_freelancer_scheduled`, searchvalue)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return await api
      .post(`/get_freelancer_scheduled`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }

  // return unassigned
}
// Update Freelancer
export function updateFreelancerReportDetails(updateFreelancer) {
  return api
    .post(`/assign_freelancer_event_team_schedule`, updateFreelancer)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

const remotes = {
  loadRecordsMetaData,
  loadFreelancerReportDetails,
  updateFreelancerReportDetails
}

export default remotes
